import { getNestedParamSource, textValues } from "./parameterParser";

export function sourceValues(
  param: Record<string, unknown>,
  sourceKey: string,
  ...directKeys: string[]
): string[] {
  const source = getNestedParamSource(param, sourceKey);
  const sourceResult = source
    ? textValues(
      source.values ??
      source.value ??
      source.vals ??
      source["set-values"] ??
      source.setValues,
    )
    : textValues(param[sourceKey]);
  if (sourceResult.length > 0) return sourceResult;

  for (const key of directKeys) {
    const directResult = textValues(param[key]);
    if (directResult.length > 0) return directResult;
  }

  return [];
}
